import { Box, Button, DialogProps } from "@mui/material";
import useWorkflows from "../../../hooks/useWorkflows";
import BasicModal from "../../components/modal/BasicModal";
import { useSnackbarHelper } from "../../components/Snackbar";

interface Props extends DialogProps {
  onClose: () => void;
  id: string;
}

const DeleteWorkFlowModal = ({ onClose, id, ...props }: Props) => {
  const { deleteWorkflow, isDeletingWorkflow } = useWorkflows(id);

  const showSnackbar = useSnackbarHelper();

  const onSubmit = async () => {
    try {
      const data = await deleteWorkflow();

      const message = data?.message || "Success";

      showSnackbar(message, "success");

      onClose();
    } catch (error: any) {
      const message = error?.response?.data?.message || "An error occurred";

      showSnackbar(message, "error");
    }
  };

  return (
    <Box>
      <BasicModal
        onClose={onClose}
        title="Delete Workflow"
        content="Do you really want to delete this workflow? "
        actions={
          <>
            <Button
              variant="contained"
              color="error"
              sx={{ textTransform: "capitalize" }}
              onClick={onSubmit}
              disabled={isDeletingWorkflow}
            >
              Delete
            </Button>
            <Button
              color="error"
              variant="outlined"
              sx={{ textTransform: "capitalize" }}
              onClick={() => onClose()}
            >
              Cancel
            </Button>
          </>
        }
        {...props}
      />
    </Box>
  );
};

export default DeleteWorkFlowModal;
